// extracted by mini-css-extract-plugin
export default {"dashBoardContainer":"Dashboard_dashBoardContainer__aXAZh","chartWrapper":"Dashboard_chartWrapper__4HLMn"};